<template>
  <div :class="session?.video ? 'res-and-student-video' : 'res-and-student'" >
    <div class="roster-actions-bar">
      <div class="select-all-label" @click="selectAllStudents">
        <div class="student-card-checkbox" :class="{ 'checked': isAllSelected }">
          <i v-if="isAllSelected" class="el-icon-check"></i>
        </div>
        <span>Select All</span>
      </div>
      <span class="clear-all-text" @click="clearallstudent">Clear All</span>
    </div>
    <div class="res-inner">
      <div class="dash-pad-hidden" v-if="!isStudent && groups && groups.length">
        <dashGroupsSelect :changeFn="groupChange"/>
      </div>
      <ul class="student-card-list">
        <li
          v-for="item in filterStudents()"
          :key="item._id"
          class="student-card-item"
          :class="{ 'is-selected': selectedMembers.includes(item._id) }"
          @click="selectUsers(item)">
          <div class="student-card-left">
            <studentAvatar :student="item" />
            <span class="student-card-name" :title="item.nickname">{{ item.nickname }}</span>
          </div>
          <div class="student-card-checkbox" :class="{ 'checked': selectedMembers.includes(item._id) }">
            <i v-if="selectedMembers.includes(item._id)" class="el-icon-check"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import dashGroupsSelect from './dashGroupsSelect.vue'
import studentAvatar from '../common/studentAvatar.vue'
export default {
  data() {
    return {
      isStudent: location.href.indexOf('/s/') > -1
    }
  },
  components: { dashGroupsSelect, studentAvatar },
  computed: {
    ...mapState(['session']),
    ...mapGetters(['getPageId']),
    ...mapGetters('student', ['selectedMembers', 'selectedGroup', 'groupMembers', 'currentPageAnswerList']),
    ...mapState('student', ['currentPageIndex']),
    ...mapState('teacher', ['groups', 'rooms']),
    ...mapState({
      allRemarks: state => state.remark.allRemarks,
      studentList: state => state.teacher.studentList,
    }),
    answeredCount() {
      const answeredSet = new Set()
      if (this.currentPageAnswerList && this.currentPageAnswerList.length) {
        for (const item of this.currentPageAnswerList) {
          const id = item.uid || item.user_id || item._id
          if (id) answeredSet.add(id)
        }
      }
      return answeredSet.size
    },
    totalStudentsCount() {
      if (this.rooms?.members && this.rooms.members.length > 0) {
        return Math.max(this.rooms.members.length, this.answeredCount)
      }
      if (this.studentList && this.studentList.length > 0) {
        return Math.max(this.studentList.length, this.answeredCount)
      }
      if (this.session?.students && this.session.students.length > 0) {
        return Math.max(this.session.students.length, this.answeredCount)
      }
      if (this.session?.regNum) {
        return Math.max(this.session.regNum, this.answeredCount)
      }
      return this.answeredCount || 0
    },
    upAnswerUserList() {
      const list = {}
      this.currentPageAnswerList.map(v => {
        list[v.uid] = 1
      })
      return list
    },
    currentComments() {
      let list = []
      if(this.getPageId && this.allRemarks.length > 0) {
        list = this.allRemarks.filter(
          item => item.page_id === this.getPageId
        );
      }
      list.reverse()
      return list;
    },
    isAllSelected() {
      const list = this.filterStudents()
      return list.length > 0 && list.every(s => this.selectedMembers.includes(s._id))
    },
  },
  mounted() {
    console.warn(this.currentPageAnswerList)
  },
  methods: {
    ...mapMutations('student', ['setSelectMembers', 'setSelectGroup', 'toggleSelectMember']),
    
    filterStudents() {
      if (this.$route.name === 's') return this.groupMembers
      if (this.selectedGroup && this.rooms?.members) return this.rooms.members.filter(v => v.group === this.selectedGroup)
      if (this.rooms?.members?.length) return this.rooms.members.filter(v => this.rooms.attend.includes(v._id))
      return this.studentList || []
    },
    selectAllStudents() {
      const list = this.filterStudents()
      const allIds = list.map(s => s._id)
      const allSelected = allIds.length > 0 && allIds.every(id => this.selectedMembers.includes(id))
      const targetIds = allSelected ? [] : allIds
      this.setSelectMembers([this.currentPageIndex, targetIds])
      if (this.session.status === 'live') {
        App.service('auth').patch('syncTeacher', {
          commit: 'student/setSelectMembers',
          to: 'teacher',
          data: [this.currentPageIndex, targetIds]
        })
      }
    },
    async groupChange(id) {
      const arr = [this.currentPageIndex, id]
      this.setSelectGroup(arr)
      if (this.session.status === 'live') App.service('auth').patch('syncTeacher', { commit: 'student/setSelectGroup', to: 'teacher', data: arr })
    },
    async selectUsers(item) {
      console.log(item)
      this.toggleSelectMember(item._id)
      if (this.session.status === 'live') App.service('auth').patch('syncTeacher', { commit: 'student/setSelectMembers', to: 'teacher', data: [this.currentPageIndex, this.selectedMembers] })
    },
    async clearallstudent() {
      this.setSelectMembers([this.currentPageIndex, []])
      if (this.session.status === 'live') App.service('auth').patch('syncTeacher', { commit: 'student/setSelectMembers', to: 'teacher', data: [this.currentPageIndex, []] })
    },
    handleExpand() {
      this.$store.dispatch('teacher/showMoreBtn', this.currentPageIndex)
    }
  }
}
</script>
<style scoped>
  .res-and-student,
  .res-and-student-video {
    width: 100%;
    height: 100%;
    min-height: 0;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }

  .roster-actions-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 14px 0;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .select-all-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 13.5px;
    font-weight: 600;
    color: #1e293b;
    user-select: none;
  }

  .clear-all-text {
    font-size: 13.5px;
    font-weight: 600;
    color: #ef4444;
    cursor: pointer;
    user-select: none;
    transition: opacity 0.2s;
  }

  .clear-all-text:hover {
    opacity: 0.8;
  }

  .res-inner {
    width: 100%;
    flex: 1 1 0;
    height: 0;
    min-height: 0;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    background: transparent;
    border: none;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 !important;
  }

  .student-card-list {
    list-style: none;
    padding: 0 4px 10px 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1 1 0;
    height: 0;
    min-height: 0;
    max-height: 100%;
    box-sizing: border-box;
  }

  .student-card-list::-webkit-scrollbar {
    width: 6px;
  }

  .student-card-list::-webkit-scrollbar-track {
    background: transparent;
  }

  .student-card-list::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  .student-card-list::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  .student-card-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
  }

  .student-card-item:hover {
    border-color: #cbd5e1;
  }

  .student-card-item.is-selected {
    border: 1.5px solid #21D999;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)),
      linear-gradient(0deg, rgba(33, 217, 153, 0.03), rgba(33, 217, 153, 0.03));
  }

  .student-card-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .student-card-name {
    font-size: 13.5px;
    font-weight: 500;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .student-card-checkbox {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1.5px solid #cbd5e1;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s ease;
  }

  .student-card-checkbox.checked {
    background: #21D999;
    border-color: #21D999;
    color: #ffffff;
    font-size: 13px;
    font-weight: bold;
  }
  .user-icon.online{
    background-color: red;
  }
  .student-icon{
    width: 44px;
    height: 44px;
    border-radius: 22px;
    line-height: 44px;
  }
  .user-name {
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 1);
    opacity: 1;
    text-align: left;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .user-time {
    font-size: 10px;
    line-height: 14px;
  }
  .ans-detail{
    flex: 1;
    background-color: rgba(228, 228, 228, 1);
    border-radius: 6px;
  }
  .notSelected{
    opacity: 0.3;
  }
  .ans-status{
    width: 21px;
    height: 21px;
    margin-right: 14px;
    box-sizing: border-box;
  }
  .ans-status.nos{
    border-radius: 50%;
    border: 1px solid #D8D8D8;
    background-color: #fff;
  }
  .showResButoon{
    width: 120px;
    height: 30px;
    border-radius: 4px;
    background-color: rgba(21, 195, 154, 1);
    font-size: 14px;
    line-height: 30px;
    color: #FFFFFF;
    cursor: pointer;
    text-align: center;
    position: relative;
    margin: 0 auto 10px auto;
  }
  .answered{
    background-image: url(../../assets/picture/answered.png);
    background-size: 24px 24px;
    /* background-position: top 5px right 5px; */
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    position: absolute;
    top: -6px;
    right: -6px;
    transform: scale(1.5);
  }
  .clearallstudent.active{
    color: #FF1A0E;
  }
  .clearallstudent{
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    color: grey;
    cursor: pointer;
    text-align: right;
    padding-right: 20px;
  }
</style>
